import React from 'react'
import { getUproColor } from 'utils/colors'
import styled from "@emotion/styled";
import Icon from "@mui/material/Icon";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { Card } from '@mui/material';
import rgba from 'assets/theme/functions/rgba';

const AnimatedIcon = styled(Icon)(({ animate, color }) => ({
    transition: "transform 0.3s",
    animation: animate ? "shakes 1s" : "none",
    color,
    "@keyframes shakes": {
        "0%": { transform: "rotate(0deg)" },
        "25%": { transform: "rotate(10deg)" },
        "50%": { transform: "rotate(-20deg)" },
        "75%": { transform: "rotate(15deg)" },
        "100%": { transform: "rotate(-5deg)" },
    },
}));

export default function CardSelection({ handleClick, animatedIcon, iconName, title, subtitle, backGround = null }) {
    return (
        <Card
            onClick={handleClick}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                padding: 2,
                backgroundColor: backGround ?`${backGround}` : getUproColor(),
                border: '1px solid black',
                cursor: 'pointer',
                transition: 'background-color 0.2s ease',
                '&:hover': { backgroundColor: rgba(getUproColor("uproYellow"), 0.7) }

            }}
        >
            <SoftBox sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 1
            }}>
                <SoftTypography variant="body2" fontWeight="bold" color="dark">
                    {title}
                </SoftTypography>
                <AnimatedIcon animate={animatedIcon} color="dark">{iconName}</AnimatedIcon>
            </SoftBox>

            <SoftTypography variant="caption" pl={.5} color="dark">
                {subtitle}
            </SoftTypography>
        </Card>
    )
}
